module.exports = {
  settings: {
    nativeApp: 'ios',
    social: {
      displayTwitter: true,
      displayFacebook: true,
    },
  },
};
